import React, { Component } from 'react';
import moment from 'moment';
import { Form, Icon, DatePicker, InputNumber, Button, Modal, Tooltip } from 'antd';
const FormItem = Form.Item;

class LoanEditDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: true
    };
  }

  handleCancel = () => {
    this.setState({
      visible: false
    });
    setTimeout(() => this.props.onHide(), 500);
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.onHandle(values);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 }
    };

    const tailFormItemLayout = {
      wrapperCol: {
        span: 8,
        offset: 6
      }
    };

    return (
      <Modal title="修改貸款" visible={this.state.visible} onCancel={this.handleCancel} footer={null}>
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label={
              <span>
                貸款起始日&nbsp;
                <Tooltip title="請參考貸款資料，填入起始日">
                  <Icon type="question-circle-o" />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('beginDate', {
              initialValue: moment(this.props.record.beginDate)
            })(<DatePicker disabled />)}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label={
              <span>
                貸款年限&nbsp;
                <Tooltip title="請參考貸款的資料，填入貸款年限">
                  <Icon type="question-circle-o" />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('period', {
              initialValue: this.props.record.period,
              rules: [
                {
                  type: 'integer',
                  required: true,
                  message: '請輸入貸款年限'
                }
              ]
            })(<InputNumber style={{ width: '200px' }} min={1} placeholder="15" />)}
            <span className="ant-form-text"> 年</span>
          </FormItem>
          <FormItem
            {...formItemLayout}
            label={
              <span>
                貸款金額&nbsp;
                <Tooltip title="請參考貸款的資料，填入貸款金額">
                  <Icon type="question-circle-o" />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('amount', {
              initialValue: this.props.record.amount,
              rules: [
                {
                  type: 'integer',
                  required: true,
                  message: '請輸入貸款金額'
                }
              ]
            })(<InputNumber style={{ width: '200px' }} min={1} placeholder="10000" />)}
            <span className="ant-form-text"> 元</span>
          </FormItem>
          <FormItem
            {...formItemLayout}
            label={
              <span>
                貸款利率&nbsp;
                <Tooltip title="請參考貸款的資料，填入貸款利率">
                  <Icon type="question-circle-o" />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('rate', {
              initialValue: this.props.record.rate,
              rules: [
                {
                  type: 'number',
                  required: true,
                  message: '請輸入利率'
                }
              ]
            })(<InputNumber style={{ width: '200px' }} max={0.5} placeholder="0.0266" />)}
          </FormItem>
          <FormItem {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">
              確定
            </Button>
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

const WrappedLoanEditDialogForm = Form.create()(LoanEditDialog);

export default WrappedLoanEditDialogForm;
